import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    root: 'flex h-9 items-center space-x-1 rounded-md bg-bg-base p-1 shadow-elevation-flyout',
  },
  styles: {
    root: {},
  },
}));
